import React from "react";
import { Play, Volume2 } from "lucide-react";
import { mediaUrl } from "../../lib/api";
import { photo } from "./racex";
import { OfferLink } from "./RacexShell";

export const RacexReel = ({ event, onWatch }) => (
  <section className="rx-reel" id="racex-film" aria-labelledby="racex-reel-title">
    <video
      className="rx-reel-video"
      poster={mediaUrl(photo("51"), 1600)}
      autoPlay
      muted
      loop
      playsInline
      preload="metadata"
      aria-hidden="true"
      tabIndex={-1}
      data-testid="racex-inline-reel-video"
    >
      <source src={mediaUrl("/api/media/racex-preview-v1.mp4")} type="video/mp4" />
    </video>
    <div className="rx-reel-scrim" aria-hidden="true" />
    <div className="rx-container rx-reel-inner">
      <p className="rx-kicker"><span className="rx-racing-slashes" aria-hidden="true"><i /><i /><i /></span>RACE DAY, TOWNSVILLE</p>
      <h2 id="racex-reel-title" data-testid="racex-reel-title">Hear the V8.<br /><em>Then come and drive it.</em></h2>
      <div className="rx-reel-actions">
        <button className="rx-button rx-reel-play" onClick={onWatch} data-testid="racex-reel-watch-button">
          <span className="rx-reel-play-icon"><Play size={18} fill="currentColor" /></span>
          Watch the full film
          <small>1:34</small>
        </button>
        {event?.accepting_enquiries && <OfferLink event={event} placement="reel" className="rx-ghost-button" />}
      </div>
      <p className="rx-reel-note" data-testid="racex-reel-note"><Volume2 size={15} aria-hidden="true" />Preview is muted. Tap play for the full film with sound.</p>
    </div>
  </section>
);
